module.exports = __webpack_public_path__ + "62d0c3360570a6843bef79ceb6376672.svg";